import { useState } from 'react';

/**
 * Custom hook for managing indication-related state
 */
export function useIndicationManagement() {
  const [indications, setIndications] = useState([]);
  const [leadChoseNotToIndicate, setLeadChoseNotToIndicate] = useState(false);

  const resetIndications = () => {
    setIndications([]);
    setLeadChoseNotToIndicate(false);
  };

  return {
    indications,
    setIndications,
    leadChoseNotToIndicate,
    setLeadChoseNotToIndicate,
    resetIndications
  };
}